import { createGlobalStyle } from "styled-components";
import Poppins100ttf from "./assets/fonts/Poppins/Poppins-Thin.ttf";
import Poppins100ittf from "./assets/fonts/Poppins/Poppins-ThinItalic.ttf";
import Poppins200ttf from "./assets/fonts/Poppins/Poppins-ExtraLight.ttf";
import Poppins200ittf from "./assets/fonts/Poppins/Poppins-ExtraLightItalic.ttf";
import Poppins300ttf from "./assets/fonts/Poppins/Poppins-Light.ttf";
import Poppins300ittf from "./assets/fonts/Poppins/Poppins-LightItalic.ttf";
import Poppins400ttf from "./assets/fonts/Poppins/Poppins-Regular.ttf";
import Poppins400ittf from "./assets/fonts/Poppins/Poppins-Italic.ttf";
import Poppins500ttf from "./assets/fonts/Poppins/Poppins-Medium.ttf";
import Poppins500ittf from "./assets/fonts/Poppins/Poppins-MediumItalic.ttf";
import Poppins600ttf from "./assets/fonts/Poppins/Poppins-SemiBold.ttf";
import Poppins600ittf from "./assets/fonts/Poppins/Poppins-SemiBoldItalic.ttf";
import Poppins700ttf from "./assets/fonts/Poppins/Poppins-Bold.ttf";
import Poppins700ittf from "./assets/fonts/Poppins/Poppins-BoldItalic.ttf";
import Poppins800ttf from "./assets/fonts/Poppins/Poppins-ExtraBold.ttf";
import Poppins800ittf from "./assets/fonts/Poppins/Poppins-ExtraBoldItalic.ttf";

import BitterMedium from "./assets/fonts/Bitter-Medium.ttf";
import Helvetica from "./assets/fonts/Helvetica.ttf";

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    height: 100%;
    font-family: Avenir, sans-serif;
  }


  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 100;
    src: url(${Poppins100ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 100;
    src: url(${Poppins100ittf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 200;
    src: url(${Poppins200ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 200;
    src: url(${Poppins200ittf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 300;
    src: url(${Poppins300ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 300;
    src: url(${Poppins300ittf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    src: url(${Poppins400ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 400;
    src: url(${Poppins400ittf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    src: url(${Poppins500ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 500;
    src: url(${Poppins500ittf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    src: url(${Poppins600ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 600;
    src: url(${Poppins600ittf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    src: url(${Poppins700ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 700;
    src: url(${Poppins700ittf}) format('truetype');
  }
  @font-face {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 800;
    src: url(${Poppins800ttf}) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-style: italic;
    font-weight: 800;
    src: url(${Poppins800ittf}) format('truetype');
  }
  

  @font-face {
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 600;
    src: url(${Helvetica}) format('truetype');
  }


  @font-face {
    font-family: 'Bitter';
    font-style: normal;
    font-weight: 400;
    src: url(${BitterMedium}) format('truetype');
  }

`;

export { GlobalStyle };
